import { render, staticRenderFns } from "./GlassBreakageRoomDamagesOriginQuestion.vue?vue&type=template&id=4d15f65d"
import script from "./GlassBreakageRoomDamagesOriginQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageRoomDamagesOriginQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports